// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"085ddf2a","453":"18847cd7","640":"00e3e46a","690":"7258c536","776":"ae6d4731","791":"8045e384"}[chunkId] + ".chunk.js";
};